var map = {
	"./blue.png": "LS6z",
	"./green.png": "4rin",
	"./lightblue.png": "5FUy",
	"./msmarker.shadow.png": "xSEJ",
	"./pink.png": "ab8V",
	"./purple.png": "tGMf",
	"./red.png": "wMDs",
	"./yellow.png": "9ed7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "FDMv";


//////////////////
// WEBPACK FOOTER
// ./static/images/GoogleMapICON/Row2 ^\.\/.*\.png$
// module id = FDMv
// module chunks = 47